import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import Sidebar from "../sidenav/Sidenav";
import {
  Button,
  Table,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  FormControl,
} from "@mui/material";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import isDesktop from "../isDesktop";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { tableCellClasses } from "@mui/material/TableCell";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TextEditor from "../Components/TextEditor/TextEditor";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


const VoucherMobile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  const [vouchersData, setVoucherData] = useState([]);
  const { id } = useParams();
  const [voucherName, setVoucherName] = useState("");
  // const [imageUrl, setImageUrl] = useState("");
  const [voucherOrder, setVoucherOrder] = useState("");
  const [voucherCode, setVoucherCode] = useState("");
  const [description, setDescription] = useState("");
  const [cost, setCost] = useState("");
  const [coins, setCoins] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [selectedVoucherId, setSelectedVoucherId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isOpen, setIsOpen] = useState({
    add: false,
    update: false,
  });

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell component="th" scope="row">
            <div>{row?.id}</div>
          </TableCell>
          <TableCell component="th" scope="row">
            <div>{row?.name}</div>
          </TableCell>
          <TableCell style={{ textAlign: "end" }}>
            <IconButton
              aria-label="expand row"
              style={{ color: "black" }}
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow
          sx={{
            "& td": { border: 0, height: open ? "auto" : 0 },
            borderBottom: "1px solid black",
          }}
        >
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderTop: "none" }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: '6px', fontSize: '10px', marginBottom: '4px' }}>
              <div>Status: {row.redeemed_by == null ||
                      row.redeemed_by == "null"
                        ? "Active"
                        : "Redeemed"}</div>
              <div
                style={{
                  fontSize: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "0.5rem",
                }}
              >
                <div style={{ flex: "1" }}>Actions:</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                  }}
                >
                     <Button
                    onClick={() => {
                      onEditClick(row?.id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#D1F4DE",
                      color: "black",
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      onVoucherDelete(row?.id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#FFD6D2",
                      color: "black",
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </div>
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const onAddClick = () => {
    setIsOpen((prev) => ({
      ...prev,
      add: true,
    }));
  };

  const fetchVouchersData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/voucher/brand/${id}`
      );

      setVoucherData(response.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  console.log(vouchersData, "vouchers data");

  useEffect(() => {
    fetchVouchersData();
  }, []);

  const onEditClick = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/voucher/${id}`
      );

      const data = response.data.data;
      setVoucherName(data.name);
      setVoucherOrder(data.voucher_order);
      setSelectedVoucherId(id);
      // setImageUrl(data.image_url);
      setVoucherCode(data.voucher_code);
      setCost(data.cost);
      setCoins(data.coins_required);
      setDescription(data.description);
      setExpiryDate(dayjs(data.expiry_date).format("YYYY-MM-DD"));
      setIsOpen((prev) => ({
        ...prev,
        update: true,
      }));
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  const onVoucherUpdate = async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/voucher/${selectedVoucherId}`,
        {
          voucherOrder: voucherOrder,
          expiryDate: expiryDate,
          voucherName: voucherName,
          // ImageURL: imageUrl,
          voucherCode: voucherCode,
          description: description,
          cost: cost,
          coinsRequired: coins,
        }
      );
      if (response.status == 200) {
        toast.success("Data updated Successfully");
        handleDialogClose();
        fetchVouchersData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  const onVoucherAdd = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/voucher`,
        {
          voucherOrder: voucherOrder,
          expiryDate: expiryDate,
          voucherName: voucherName,
          // ImageURL: imageUrl,
          brandId: id,
          voucherCode: voucherCode,
          description: description,
          cost: cost,
          coinsRequired: coins,
        }
      );

      if (response.status == 200) {
        toast.success("Data added successfully");
        handleDialogClose();
        fetchVouchersData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  const onVoucherDelete = (id) => {
    setSelectedVoucherId(id);
    setDeleteOpen(true);
  };

  const handleDialogClose = () => {
    setVoucherName("");
    setVoucherOrder("");
    // setImageUrl("");
    setCoins("");
    setCost("");
    setDescription("");
    setVoucherCode("");
    setExpiryDate("");
    setIsOpen({
      add: false,
      update: false,
    });
  };

  const handleDateChange = (value) => {
    console.log(dayjs(value).format("DD-MM-YYYY"), " handleDateChange"); // '16-12-2001'
    const formattedDate = dayjs(value).format("YYYY-MM-DD");
    setExpiryDate(formattedDate);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/voucher/${selectedVoucherId}`
      );
      if (response.status == 200) {
        toast.success("Data updated Successfully");
        setDeleteOpen(false);
        fetchVouchersData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };
  const handleBack = () => {
    navigate("/rewards");
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0.75rem 1.25rem 0.75rem",
        }}
      >
        <div
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "36px",
            height: "36px",
            borderRadius: "18px",
            background: "#EAF1F7",
          }}
        >
          <Hemberger />
        </div>
        <Link to={"/profile"}>
          <UserIcon style={{ cursor: "pointer" }} />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0rem 0.75rem 1.5rem 0.75rem",
        }}
      >
        <div className="container-fluid">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom:"2.25rem"
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
                
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  handleBack();
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
                Vouchers
              </h4>
            </div>
            <Button
              onClick={onAddClick}
              className="button-two"
              style={{
                width: "6rem",
                height: "1.75rem",
                background: "#37446F",
              }}
            >
              Add
            </Button>
          </div>
          <Table
            aria-label="collapsible table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <TableHead
              style={{
                height: "44px",
                borderRadius: "4px !important",
                background: "rgba(234, 241, 247, 1)",
                boxShadow: "2px 2px 4px 0px rgba(174, 174, 192, 0.5)",
              }}
            >
              <TableRow>
                <TableCell>S. No.</TableCell>
                <TableCell>Voucher Name</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {vouchersData?.map((brand, ind) => (
                <Row key={ind} row={brand} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <Dialog open={isOpen.add || isOpen.update} onClose={handleDialogClose}>
          <DialogTitle style={{ fontWeight: "600" }}>
            {isOpen.add ? "Add New voucher" : "Update voucher"}
          </DialogTitle>
          <DialogContent>
            <TextField
              name="name"
              type="text"
              fullWidth
              className="mt-3"
              label="Voucher Name"
              value={voucherName}
              onChange={(e) => {
                setVoucherName(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            />
            <TextField
              name="order"
              type="text"
              fullWidth
              className="mt-3"
              label="Voucher Order"
              value={voucherOrder}
              onChange={(e) => {
                setVoucherOrder(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            />
            {/* <TextField
              name="imageUrl"
              type="text"
              fullWidth
              className="mt-3"
              label="Image Url"
              value={imageUrl}
              onChange={(e) => {
                setImageUrl(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            /> */}
            <FormControl
              fullWidth
              className="mb-3 mt-3"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
                "&.Mui-focused": { color: "#A8A8A8" },
              }}
              style={{
                boxShadow:
                  "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
              }}
            >
              {" "}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="YYYY-MM-DD"
                  value={dayjs(expiryDate)}
                  label="Expiry Date"
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField {...params} error={false} />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
            <div
              style={{
                marginTop: "16.5px",
              }}
            >
              <TextEditor
                propsContent={description}
                propPlaceholder={"Short Description...."}
                onChangeContent={(value) => {
                  setDescription(value);
                }}
              />
            </div>
            <TextField
              name="voucherCode"
              type="text"
              fullWidth
              className="mt-3"
              label="Voucher Code"
              value={voucherCode}
              onChange={(e) => {
                setVoucherCode(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            />
            <TextField
              name="cost"
              type="text"
              fullWidth
              className="mt-3"
              label="Cost"
              value={cost}
              onChange={(e) => {
                setCost(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            />
            <TextField
              name="coins"
              type="text"
              fullWidth
              className="mt-3"
              label="Coins"
              value={coins}
              onChange={(e) => {
                setCoins(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                required: false,
              }}
              InputProps={{
                style: {
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                },
              }}
            />
          </DialogContent>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1.282vw",
              padding: "24px",
              paddingTop: "0",
            }}
          >
            <Button
              className="outlined-button"
              style={{ flex: "1", width: "auto !important" }}
              onClick={() => {
                handleDialogClose();
              }}
            >
              Cancel
            </Button>
            <Button
              className="filled-button"
              style={{ flex: "1", width: "auto !important" }}
              onClick={() => {
                isOpen.add ? onVoucherAdd() : onVoucherUpdate();
              }}
            >
              {isOpen.add ? "Add" : "Update"}
            </Button>
          </div>
        </Dialog>
        <Dialog
          open={deleteOpen}
          onClose={(prev) => !prev}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ textAlign: "center" }}
        >
          <ErrorOutlineIcon
            style={{ color: "red", fontSize: "32px", margin: "12px auto" }}
          />
          <DialogTitle
            id="alert-dialog-title"
            style={{ fontSize: "18px", fontWeight: "500", lineHeight: "0" }}
          >
            {"Are you Sure?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ fontSize: "12px" }}
            >
              You won't be able to revert this!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteOpen(false)}
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                border: "2.03px solid #37446F",
                borderRadius: "5.85px",
                background: "none",
                color: "black",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                borderRadius: "5.85px",
                background: "#37446F",
                color: "white",
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
    </>
  );
};

export default VoucherMobile;
